<template>
  <div class="common-content">
    <ul>
      <li v-for="(item,index) in article" :key="index" @click="detail(item.newsId)">
        <span style="width:10px;height:10px;opacity:0.8;position: absolute;top: 10%;">.</span>
        <div style="margin-left:10px;height:50px;">
          <a href="javascript:;">
            <div class="common-content-item">
              <div class="content-title">{{item.title}}</div>
              <div class="content-date">{{item.createTime}}</div>
            </div>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    article: Array,
  },
  methods: {
    detail(id) {
      this.$emit("detail", id);
    },
  },
};
</script>

<style lang="less" scoped>
.common-content {
  padding: 10px;
  .common-content-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px dashed #dddddd;
    line-height: 40px;
    .content-title {
      color: #333333;
      font-size: 17px;
    }
    .content-date {
      color: #aaaaaa;
      font-size: 15px;
    }
  }
  ul {
    margin: 0;
    padding: 5px;
    li {
      font-size: 18px;
      list-style: none;
      position: relative;
      a {
        text-decoration: none;
        color: #7d7d7d;
      }
    }
  }
}
</style>